import React, { useEffect, useState } from 'react'
import { Card, Grid, makeStyles, Typography, Container } from '@material-ui/core'
import LoadingBeforeViewData from '../compartidos/LoadingBeforeViewData';
import { useHistory, useParams } from 'react-router';
import { startAlerta } from '../../actions/ui/alertas';
import { useDispatch } from 'react-redux';
import RecetasDigitalesService from '../../services/RecetasDigitalesService';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    container: {
        marginLeft: "auto",
        marginRight: "auto",
        padding: "1rem",
        display: "block",
        borderRadius: 15
    },
    img: {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "1rem",
        width: "50%"
    },
    title: {
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "0.75rem",
        fontSize: "0.70rem",
        display: "block"
    }
}));

const ControlRecetaDigital = () => {
    const classes = useStyles()
    const history = useHistory()
    const dispatch = useDispatch()

    const [data, setData] = useState(null);
    const [especialidades, setEspecialidades] = useState(null);

    const { idReceta } = useParams();

    const getDataReceta = async () => {
        try {
            const result = await RecetasDigitalesService.getData(idReceta)
            const body = await result.json()
            if (result.ok) {
                setData(body)
            } else {
                throw body.errores
            }
        } catch (error) {
            console.log("Hubo un error al traer la información de la receta")
            history.push("/auth/login")
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            }
        }
    };

    const getEspecialidades = async () => {
        try {
            const result = await RecetasDigitalesService.getEspecialidadesPublic(idReceta)
            const body = await result.json()
            if (result.ok) {
                setEspecialidades(body)
            } else {
                throw body.errores
            }
        } catch (error) {
            console.log("Hubo un error al traer las especialidades")
            history.push("/auth/login")
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            }
        }
    };

    useEffect(() => {
        //dispatch(fetchEspecialidades(true))
        getDataReceta();
        getEspecialidades();
    }, [])

    if (data === null) {
        return <LoadingBeforeViewData />
    }


    // const especialidad = especialidades?.find(
    //     (e) => e.idEspecialidades === data.usuario.idEspecialidad
    // );


    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Grid container >
                    <Grid item xs={12} md={6} className={classes.container} elevation={6} component={Card} variant="outlined">
                        <Typography variant="h5" align="center">Información de la Receta Digital N°{data.idRecetaDigital}</Typography>
                        <Typography variant="overline" align="center" className={classes.title}>Afiliado:</Typography>
                        <Typography align="center" style={{ fontWeight: "bold" }}>{data.afiliado.apellido_y_nombre}</Typography>

                        <Typography variant="overline" align="center" className={classes.title}>Carnet N°</Typography>
                        <Typography align="center" style={{ fontWeight: "bold" }}>{data.afiliado.carnet}</Typography>

                        <Typography variant="overline" align="center" className={classes.title}>Farmacos Recetados</Typography>

                        {data.medicamentos.map((medicamento) => {
                            var drogas = null;

                            if (medicamento.medicamento.drogas.length > 30) {
                                drogas = medicamento.medicamento.drogas.substring(0, 30) + " [...]";
                            } else {
                                drogas = medicamento.medicamento.drogas;
                            }
                            return (
                                <Typography align="center" style={{ fontWeight: "bold" }}>{medicamento.cantidad} - {drogas} - {medicamento.medicamento.presentacion}</Typography>
                            );
                        })}

                        <Typography variant="overline" align="center" className={classes.title}>Diagnostico</Typography>
                        <Typography align="center" style={{ fontWeight: "bold" }}>{data.diagnostico.problema}</Typography>

                        <Typography variant="overline" align="center" className={classes.title}>Profesional</Typography>
                        <Typography align="center" style={{ fontWeight: "bold" }}>{data.usuario.userName}</Typography>

                        {data.usuario.especialidadesUsuarios?.map((id) => {
                            const especialidad = especialidades?.find(
                                (e) => e.idEspecialidades === id
                            );

                            return (
                                <Typography align="center" style={{ fontWeight: "bold" }}>{especialidad?.descripcionEspecialidades}</Typography>
                            );
                        })}

                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default ControlRecetaDigital